import React from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import exportFromJSON from 'export-from-json';
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)


const LineChart:  any = (props:any) => {
    // console.log(props.allData);
    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");
    const {allData, exportExcel, labels, title, subtitle, idChart, activeButton, colores,tituloY='Value',visibleLabelsX=true} = props;
    // @ts-ignore
	// @ts-ignore
	const options = {
		chart: {
            type: 'column',
            backgroundColor: '#f0f0f0',
			colorCount: 15,
        },
		title: {
			text: title
		},
	
		subtitle: {
			text: subtitle
		},
	
		yAxis: {
			title: {
				text: tituloY, // Aquí puedes cambiar el título del eje Y
			},
			labels:{
				format: '{value}%'
			}
		},

		
	
		xAxis: {
			categories : labels,
			max: (labels.length - 1),
            crosshair: true,
			visible: visibleLabelsX,
		},

		tooltip: {
			shared: true,
			useHTML: true,
			headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
			pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
				'<td style="text-align: right"><b>{point.y}%</b></td></tr>',
			footerFormat: '</table>',
			valueDecimals: 0
		},
	
	
		plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            },
			series: {
				borderWidth: 0,
				dataLabels: {
					enabled: true,
					// @ts-ignore
					formatter: function() {
						// Usa 'this.point.color' para obtener el color del punto
						// @ts-ignore
						return '<span style="color:' + this.point.color + '">' + this.point.y + '%'  +'</span>';
					}

				}
			}
        },
	
		series: allData,
		// colors: ['#00A3E0', '#8031A7', '#B5BD00', '#ed8b00', '#09699c', '#ffc000', '#E0004D',
		// 		 '#00C389', '#707372', '#bfbfbf'],
		colors: colores,
		legend: {
			enabled: true,
			align: 'center',
			verticalAlign: 'bottom',
			layout: 'horizontal'
		},
	
		responsive: {  
			rules: [{  
			  condition: {  
				maxWidth: 1000
			  },  
			  chartOptions: {
				  legend: {
					  enabled: true,
					  align: 'center',
					  verticalAlign: 'top',
					  layout: 'horizontal'
				  },
               
                subtitle: {
                    text: subtitle
                },
                credits: {
                    enabled: false
                }
            }
			}]  
		  },
		  
		  lang: {
			downloadCSV: 'Descargar CSV',
			downloadJPEG: "Descargar JPEG",
			downloadPDF: "Descargar PDF",
			downloadPNG: "Descargar PNG",      
			downloadSVG: "Descargar SVG",
			downloadXLS: "Descargar XLS",
			exitFullscreen: "Salir de pantalla completa",
			viewFullscreen: "Ver Pantalla Completa",
			printChart: "Imprimir Gráfico"
		  },

		  exporting: {
			enabled: activeButton, 
			menuItemDefinitions: {
				// Custom definition
				label: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportExcel({titulo: title, id: idChart});
					},
					text: 'Descargar XLSX'
				}
			},
			
			buttons: {
				contextButton: {
					menuItems: [
						"viewFullscreen",
						"printChart",
						"separator",
						"downloadPNG",
						"downloadJPEG",
						"downloadPDF",
						"downloadSVG",
						"separator",
						"label"
					]
				}
			}
		},
		credits: {
			enabled: false
		}
	}

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </>
    )
}

export default LineChart;
